import { kindWord } from "@/lib/attributeReview/kindWords";
import { cn } from "@/lib/utils";

type Props = {
  options: string[];
  kind: string | null;
  onKind: (kind: string) => void;
};

export function KindChips({ options, kind, onKind }: Props) {
  return (
    <>
      {options.map((option) => (
        <button
          key={option}
          type="button"
          aria-pressed={kind === option}
          onClick={() => onKind(option)}
          className={cn(
            "rounded-full border px-2.5 py-0.5 text-xs focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500",
            kind === option
              ? "border-indigo-300 bg-indigo-50 text-indigo-700 dark:border-indigo-700 dark:bg-indigo-950/40 dark:text-indigo-300"
              : "border-slate-200 text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800",
          )}
        >
          {kindWord(option)}
        </button>
      ))}
    </>
  );
}
